import { NotificationType } from './notification-type.enum';

export class Notification {
  message: string;
  type: NotificationType;
  copyText?: string;
  copied?: boolean;

  constructor(message: string, type: NotificationType, copyText?: string) {
    this.message = message;
    this.type = type;
    this.copyText = copyText;
    this.copied = false;
  }
}
